import { TAB } from '~/constants/Tab';

import { LOG, log } from '~/utils/logging';

/**
 * Handles the selection of a filter group.
 *
 * @param {string} filterGroupId - The ID of the selected filter group.
 * @param {Array} filterGroups - The array of filter groups.
 * @param {string} selectedFilterGroup - The ID of the currently selected filter group.
 * @param {function} setDelivery_selectedFilterGroup - The function to set the selected filter group.
 * @param {object} userFeatureFlags - Object containing user feature flags.
 * @param {function} handleChangeFilterGroup - The function to handle changing the filter group.
 * @param {boolean} isPermittedSiteAllowedUser - Boolean value includes isPermittedSiteAllowedUser.
 */
export const handleSelectFilterGroup = (
  dispatch,
  filterGroupId,
  filterGroups,
  selectedFilterGroup,
  setDelivery_selectedFilterGroup,
  userFeatureFlags,
  handleChangeFilterGroup,
  tabOffset,
  isPermittedSiteAllowedUser,
) => {
  if (filterGroupId === selectedFilterGroup) {
    return;
  }

  dispatch(setDelivery_selectedFilterGroup(filterGroupId));
  handleChangeFilterGroup(filterGroups.find(({ id }) => id === filterGroupId));

  const selectedTab = filterGroups.findIndex(({ id }) => id === filterGroupId);

  if (selectedTab === TAB.DELIVERY.LIST.INDEX) {
    log.productAnalyticsEvent(
      'Open delivery list filter group',
      LOG.FEATURE.FILTER_GROUPS,
    );
  }

  if (
    selectedTab === TAB.DELIVERY.UNASSIGNED_DELIVERY_NOTES.INDEX &&
    (userFeatureFlags.accessPermittedSites || isPermittedSiteAllowedUser)
  ) {
    log.productAnalyticsEvent(
      'Open unassigned deliveries filter group',
      LOG.FEATURE.SITE_MAPPING,
    );
  }

  if (selectedTab >= tabOffset) {
    log.productAnalyticsEvent(
      'Open custom delivery filter group',
      LOG.FEATURE.FILTER_GROUPS,
    );
  }
};
